import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { InView } from "react-intersection-observer";
import GA from './components/utility/GA';
import ScrollToTop from "./components/utility/ScrollToTop";

import Nav from "./components/Nav";
import { Footer } from "./components/Footer";

import Top from "./pages/Top";
import System from "./pages/System";
import Character from "./pages/Character";
import Product from "./pages/Product";

import './styles/app.scss'
import './styles/index.scss'

function App() {

  return (
    <div className="App">
      <Router basename={process.env.PUBLIC_URL}>
        <GA GA4="G-5DTQ35HVL9"/>
        <Nav/>
        <ScrollToTop>
          <InView>
            <Routes>
              <Route exact path="/" element={<Top/>}/>
              <Route path="/system" element={<System/>}/>
              <Route path="/character" element={<Character/>}/>
              {
                /*
                  <Route path="/product" language="ENG" element={<Product/>}/>
                */
              }
            </Routes>
          </InView>
        </ScrollToTop>
        <Footer/>
      </Router>  
    </div>
  );
}

export default App;